import $ from 'jquery';
import Cookies from 'js-cookie';
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp } from '../js/firebaseConfig';

$(document).ready(function() {
  //GET COOKIE
  const formDataCookie = Cookies.get('formData');
  if (formDataCookie) {
    const formData = JSON.parse(formDataCookie);
    $('#email').val(formData.email || '');
    $('#company').val(formData.company || '').addClass('valid').css('pointer-events', 'none');
  }

  //VERIFS INPUT
  const phoneInputField = document.querySelector("#phone");
  const phoneInput = window.intlTelInput(phoneInputField, {
    initialCountry: "fr",
    preferredCountries: ['fr'],
    geoIpLookup: function(success, failure) {
      $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
        const countryCode = (resp && resp.country) ? resp.country : "us";
        success(countryCode);
      });
    },
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js"
  });
  function validatePassword(password) {
    const length = password.length >= 6 && password.length <= 16;
    const upperCase = /[A-Z]/.test(password);
    const lowerCase = /[a-z]/.test(password);
    const number = /[0-9]/.test(password);
    return { length, upperCase, lowerCase, number };
  }
  function checkForm() {
    const email = $('#email')[0].checkValidity();
    const firstName = $('#firstName').val().trim() !== '';
    const lastName = $('#lastName').val().trim() !== '';
    const phone = $('#phone').val().trim() !== '';
    const website = $('#website').val().trim() !== '';
    const company = $('#company').val().trim() !== '';
    const password = $('#password').val();
    const confirmPassword = $('#ConfirmPassword').val();
    const terms = $('#terms').is(':checked');
    const privacy = $('#privacy').is(':checked');

    if (email && firstName && lastName && phone && website && company && terms && privacy && password === confirmPassword) {
      $('#createAccount').addClass('valid');
    } else {
      $('#createAccount').removeClass('valid');
    }
  }
  function validateInput(input, isValid) {
    if (isValid) {
      input.addClass('valid');
    } else {
      input.removeClass('valid');
    }
  }
  $('#email').on('input', function() {
    const isValid = $(this)[0].checkValidity();
    validateInput($(this), isValid);
    checkForm();
  });
  $('#firstName, #lastName, #phone, #website, #company').on('input', function() {
    validateInput($(this), $(this).val().trim() !== '');
    checkForm();
  });
  $('input[type=checkbox]').on('change', function() {
    checkForm();
  });
  $('#password, #ConfirmPassword').on('input', function() {
    const password = $('#password').val();
    const confirmPassword = $('#ConfirmPassword').val();
    const validation = validatePassword(password);

    $('#charLength').toggleClass('valid', validation.length);
    $('#upperCase').toggleClass('valid', validation.upperCase);
    $('#lowerCase').toggleClass('valid', validation.lowerCase);
    $('#number').toggleClass('valid', validation.number);

    validateInput($('#password'), validation.length && validation.upperCase && validation.lowerCase && validation.number);
    validateInput($('#ConfirmPassword'), confirmPassword === password && confirmPassword.trim() !== '');

    if (password || confirmPassword) {
      $('.password').show();
    } else {
      $('.password').hide();
    }
    checkForm();
  });

  //SAVE INPUT
  $('#createAccount').on('click', async function(event) {
    event.preventDefault();
  
    const email = $('#email').val();
    const firstName = $('#firstName').val();
    const lastName = $('#lastName').val();
    const phone = $('#phone').val();
    const website = $('#website').val();
    let companyName = $('#company').val();
    const password = $('#password').val();
    const confirmPassword = $('#ConfirmPassword').val();

    $(this).text('Loading ...');
    $(this).addClass('loading');
    
    companyName = companyName.toLowerCase();
  
    if (password !== confirmPassword) {
      alert('Passwords do not match');
      $(this).removeClass('loading');
      $(this).text('Sign up');
      return;
    }

    try {
      let companyDoc = await getCompanyByName(companyName);

      let companyId;
      let userRole = 'user';
      
      if (!companyDoc) {
        companyId = await createCompany({
          name: companyName,
          createdAt: serverTimestamp()
        });
      } else {
        companyId = companyDoc.id;
        userRole = 'sales';
      }

      const formDataCookie = Cookies.get('formData');
      const userData = {
          name: `${firstName} ${lastName}`,
          phone: phone,
          website: website,
          companyId: companyId,
          role: userRole,
          timestamp: serverTimestamp(),
          ...(formDataCookie && { formdata: 'true' })
      };
      await registerUser(email, password, userData);
      if ($('body').hasClass('userDetail')) {
        location.reload();
      } else {
        Cookies.set('userMail', email);
        Cookies.set('companyId', companyId);
        Cookies.remove('formData');
        window.location.href = 'https://www.salesridge.co/assessment.html';
      }
    } catch (error) {
      console.error('Error creating account: ', error);
      $(this).removeClass('loading');
      $(this).text('Sign up');
      alert('Error creating account: ' + error.code);
    }
  });

});
